import React from 'react'
import './comments.css'
import Avatar1 from '../../assets/avatar1.jpg'
import Avatar2 from '../../assets/avatar2.jpg'
import Avatar3 from '../../assets/avatar3.jpg'
import Avatar4 from '../../assets/avatar4.jpg'

// import Swiper core and required modules
import {  Pagination } from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import { Autoplay } from "swiper";

const data = [
  {
    avatar: Avatar1,
    name: 'Ernest Achiever',
    review: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eligendi voluptatum, optio similique eum nisi totam quidem unde minus suscipit a libero autem doloremque numquam officiis vel sequi. Quia, porro mollitia.'
  },
  {
    avatar: Avatar2,
    name: 'Tina Show',
    review: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eligendi voluptatum, optio similique eum nisi totam quidem unde minus suscipit a libero autem doloremque numquam officiis vel sequi. Quia, porro mollitia.'
  },
  {
    avatar: Avatar3,
    name: 'Tina Show',
    review: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eligendi voluptatum, optio similique eum nisi totam quidem unde minus suscipit a libero autem doloremque numquam officiis vel sequi. Quia, porro mollitia.'
  },
  {
    avatar: Avatar4,
    name: 'Tina Show',
    review: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eligendi voluptatum, optio similique eum nisi totam quidem unde minus suscipit a libero autem doloremque numquam officiis vel sequi. Quia, porro mollitia.'
  },
]


const comments = () => {
  return (
    <section id='testimonials'>
      <h5>Review from clients</h5>
      <h2>Testimonials</h2>

      <Swiper className="container testimonials_container" // install Swiper modules
      modules={[Autoplay, Pagination]}
      // modules={[ Pagination ]}
      spaceBetween={40}
      slidesPerView={1}
      loop={true}

      autoplay={{
        delay: 2500,
        disableOnInteraction: false,
      }}

      pagination={{ clickable: true }}
      >
        {
          data.map(({avatar, name, review}, index) => {
            return(
              <SwiperSlide key={index} className="testimonial">
          <div className="client_avatar">
            <img src={avatar} alt="Avatar1" />
          </div>
            <h5 className='client_name'>{name}</h5>
            <small className='client_review'>{review}</small>
        </SwiperSlide>
            )
          })
        }
      </Swiper>
    </section>
  )
}

export default comments